import { makeStyles } from '@material-ui/core';
import { Link } from '@backstage/core-components';
import { cockpitTokens } from './cockpitTokens';
import { useHomeSources } from './homeSources';

/**
 * The one hint the home page gives a colleague in no team (DX-546;
 * specs/home-page.md AC-29).
 *
 * Until DX-546 the state was said three times on the page — as a caption under
 * the owned figure, as the empty text of the ownership card, and as a row of
 * the attention card — and each named a different remedy. Now the figure shows
 * a dash, the card stays off the page, and this card says what the state is
 * and who ends it: a colleague's teams are the GitHub teams of the revenexx
 * organisation (ADR-0104), so it is a team maintainer or an organisation owner
 * who adds them, not an admin of the portal. Rendered only while the reader is
 * in no team; the rest of the time it is nothing.
 *
 * MUI v4 only.
 */

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    borderRadius: cockpitTokens.radius.card,
    border: `1px solid ${cockpitTokens.color.border}`,
    background: cockpitTokens.color.surface,
    boxShadow: cockpitTokens.shadow.card,
  },
  title: {
    margin: 0,
    fontSize: '0.95rem',
    fontWeight: 600,
    color: cockpitTokens.color.text,
  },
  text: {
    margin: theme.spacing(1, 0, 0),
    fontSize: '0.85rem',
    lineHeight: 1.5,
    color: cockpitTokens.color.textMuted,
  },
  link: {
    display: 'inline-block',
    marginTop: theme.spacing(1.5),
    fontSize: '0.85rem',
    fontWeight: 500,
    color: cockpitTokens.color.brand,
  },
}));

export const TeamNotSet = () => {
  const classes = useStyles();
  const { reader } = useHomeSources();
  if (!reader.data || reader.data.inTeam) return null;
  return (
    <section
      aria-labelledby="team-not-set-title"
      className={classes.root}
      data-state="team-not-set"
    >
      <h2 id="team-not-set-title" className={classes.title}>
        Your team is not set
      </h2>
      <p className={classes.text}>
        Your GitHub user is in no team of the revenexx organisation, so the
        portal sees only what your own user owns, not your team's components. A
        maintainer of your team, or an owner of the organisation, adds you to
        the team on GitHub; the portal reads the teams every 30 minutes, and the
        change reaches you at your next sign-in. Until then, Needs attention
        lists the failing builds of all teams, not yours.
      </p>
      <Link to="/access" className={classes.link}>
        Request team membership
      </Link>
    </section>
  );
};
